(function() {
    /**
     *
     */
    angular.module('graph').directive('phStaticDate', ['ph-date-service', function ($time) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attr) {
                $scope.$watch(function () {
                    return $attr['date'];
                }, function (n, o) {
                    $element.text(
                        $time.$convert(
                            $attr['date']
                        ).format('LL LT')
                    );
                }, true);
            }
        };
    }]);

    angular.module('graph').directive('phConfirmDelete', [
        function() {
            return {
                terminal: true,
                priority: 1,
                link: function($scope, $element, $attr) {
                    var msg = $attr.phConfirmDelete || 'Are you sure?';
                    var clickAction = $attr.ngClick;
                    var modal = angular.element('#modal-confirm');

                    $element.bind('click', function() {
                        modal.addClass('show');

                        modal.find('.ph-modal-content').html(msg);

                        modal.find('.confirm-delete').bind('click', function() {
                            $scope.$eval(clickAction);
                            modal.removeClass('show');
                        });

                        angular.element('body').click(function (e) {
                            if (angular.element(e.target).hasClass('modal-window') ||
                                angular.element(e.target).hasClass('cancel-delete')) {
                                modal.removeClass('show');

                                e.stopPropagation();
                            }
                        });
                    });
                }
            }
        }
    ]);

    angular.module('graph').directive('phTimeMask', [
        '$timeout',
        function ($timeout) {
            return {
                require: 'ngModel',
                restrict: 'A',
                link: function ($scope, $element, $attr, $ctrl) {
                    $timeout(function () {
                        var $pattern = "([01]?[0-9]|2[0-3]):[0-5][0-9]";

                        if ($ctrl.$viewValue.match(new RegExp($pattern, "i")) === null) {
                            newVal = '00:00';

                            $ctrl.$setViewValue(newVal);
                            $ctrl.$render();
                        }

                        $element.bind("keypress", function (e) {
                            var keyCode     = e.which || e.keyCode,
                                keyCodeChar = String.fromCharCode(keyCode),
                                currentVal  = $ctrl.$viewValue,
                                newVal;

                            if (!keyCodeChar.match(new RegExp("[0-9]", "i")) || currentVal.length >= 5) {
                                e.preventDefault();
                                return false;
                            }

                            newVal = currentVal + keyCodeChar;

                            if (currentVal.length == 0 && parseInt(newVal) > 2) {
                                newVal = '0' + newVal;
                            }

                            if (currentVal.length == 1) {
                                if (/[4-5]/g.test(keyCodeChar) && parseInt(currentVal) === 2) {
                                    newVal = '0' + currentVal + ':' + keyCodeChar;
                                } else if (newVal.match(new RegExp("^([01]?[0-9]|2[0-3])$")) === null) {
                                    e.preventDefault();
                                    return false;
                                }
                            }

                            if (currentVal.length == 2) {
                                newVal = currentVal + ':' + keyCodeChar;
                            }

                            if (newVal.length == 4) {
                                if (newVal.match(new RegExp("([01]?[0-9]|2[0-3]):[0-5]", "i")) === null) {
                                    e.preventDefault();
                                    return false;
                                }
                            }

                            if (newVal.length == 5) {
                                if (newVal.match(new RegExp("([01]?[0-9]|2[0-3]):[0-5][0-9]", "i")) === null) {
                                    e.preventDefault();
                                    return false;
                                }
                            }

                            $ctrl.$setViewValue(newVal);
                            $ctrl.$render();
                            e.preventDefault();
                            $scope.$apply();

                        });

                        $element.bind('blur', function (e) {
                            var value = $ctrl.$viewValue;

                            if (!value.match(new RegExp("([01]?[0-9]|2[0-3]):[0-5][0-9]", "i"))) {
                                value = '00:00';
                            }

                            $ctrl.$setViewValue(value);
                            $ctrl.$render();
                            e.preventDefault();
                            $scope.$apply();
                        });
                    });

                }
            };
        }
    ]);

    /**
     *
     */
    angular.module('graph').directive('phBlur', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {

                $(document).mouseup(function(e) {
                    var container = $(element);

                    if (!container.is(e.target)
                        && container.has(e.target).length === 0
                    ) {
                        scope.$apply(attr.phBlur);
                    }
                });
            }
        }
    });

    angular.module('graph').directive('phPreview', [
        '$timeout',
        '$rootScope',
        function ($timeout, $root) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr) {
                    $timeout(function() {
                        $scope.$watch($attr.phPreview, function($data) {
                            var images = $element.find('img');

                            angular.forEach(
                                $element.find('img'), function(image, k) {
                                    angular.element(
                                        image
                                    ).attr('ph-preview-id', k);
                                }
                            );

                            var call = function(e) {
                                $root.$broadcast('ph-preview-touch', {
                                    images  : typeof $data === 'function' ?
                                        $data() : $data,
                                    current : parseInt(
                                        angular.element(
                                            e.target
                                        ).attr(
                                            'ph-preview-id'
                                        )
                                    )
                                });
                            };

                            images.unbind(
                                'click', call
                            ).bind(
                                'click', call
                            );
                        });
                    });
                }
            }
        }
    ]);

    /**
     *
     */
    angular.module('graph').directive('phStaticDateBetween', ['ph-date-service', function ($time) {
        return {
            restrict: 'A',
            link: function ($scope, element, attr) {
                if (!attr.glue) attr.glue = ' - ';

                $scope.$watch(function () {
                    return element.attr('start') + attr.glue + element.attr('end');
                }, function (n, o) {
                    var start   = $time.$convert(new Date(attr.start));
                    var end     = $time.$convert(new Date(attr.end));

                    if (start.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')) {
                        element.text(start.format('LL LT') + attr.glue + end.format('LT'));
                    } else {
                        element.text(start.format('LL LT') + attr.glue + end.format('LL LT'));
                    }
                }, true);
            }
        };
    }]);

    /**
     *
     */
    angular.module('graph').directive('phWatchDate', ['$interval', 'ph-date-service', function ($interval, $time) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attr) {
                var $watch, $commit, $text, $date = $time.$convert(
                    $attr.phWatchDate
                ), $timeout = 60001;

                function calculate() {
                    $commit = $time.$new().diff($date, 'seconds');

                    if ($commit < 86400) {
                        $element.text($date.fromNow());
                    } else {
                        $timeout  = 86400001;
                        $text   = $date.format('lll');
                        $element.text($text);
                    }

                    /*if ($commit < 60) {
                        $text = 'Just now';
                        $timeout  = 60001;
                        $element.text($text);
                    } else if ($commit < 3600) {
                        $timeout  = 60001;
                        $text   = parseInt($commit / 60) + ' m ago';
                        $element.text($text);
                    } else if ($commit < 86400) {
                        $timeout  = 3600001;
                        $text   = parseInt($commit / 3600) + ' h ago';
                        $element.text($text);
                    } else {
                        $timeout  = 86400001;
                        $text   = $date.format('lll');
                        $element.text($text);
                    }*/
                }

                calculate();

                $scope.$watch(function () {
                    return $attr['date'];
                }, function (o, n) {
                    $date = $time.$convert(
                        $attr['date']
                    );

                    if ($watch)
                        $interval.cancel($watch);

                    $watch = $interval(
                        calculate, $timeout
                    );
                }, true);
            }
        };
    }]);

    /**
     *
     */
    angular.module('graph').directive('elastic', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    $scope.$watch(function () {
                        return element[0].value;
                    }, function (o, n) {
                        if (o !== n)
                            resize();
                    });
                    $scope.initialHeight = $scope.initialHeight || element[0].style.height;
                    var resize = function () {
                        element[0].style.height = $scope.initialHeight;
                        element[0].style.height = "" + element[0].scrollHeight + "px";
                    };
                    $timeout(resize, 0);
                }
            };
        }
    ]);

    /**
     *
     */
    angular.module('graph').directive('ucfirst', [
        function () {
            return {
                restrict: 'E',
                scope: {
                    val: '='
                },
                link: function ($scope, element) {
                    scope.$watch('$stateChangeSuccess', function (nval, oval) {
                        if (nval) {
                            var s = element.text();
                            var f = s.charAt(0).toUpperCase();

                            console.log(s);

                            element.text(f + s.substr(1, s.length - 1));
                        }
                    }, true);
                }
            };
        }
    ]);

// angular.module('graph').directive('fixed', ['$window', function ($window) {
//   var $win = angular.element($window); // wrap window object as jQuery object
//
//   return {
//     restrict: 'A',
//     link: function (scope, element, attrs) {
//
//       var topClass = attrs.fixed, // get CSS class from directive's attribute value
//           offsetTop = element[0].getBoundingClientRect().top; // get element's offset top relative to document
//
//       $win.on('scroll', function (e) {
//           var i = $win.getComputedStyle(element[0],null).getPropertyValue("height").replace(/px/,"");
//         if (i >= offsetTop) {
//           element.addClass(topClass);
//         } else {
//           element.removeClass(topClass);
//         }
//       });
//     }
//   };
// }]);

    /**
     *
     */
    angular.module('graph').directive('compactText', [
        '$timeout', '$filter',
        function ($timeout, $filter) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr) {
                    $scope.$watch(function () {
                        return $attr['compactText'];
                    }, function (nval, oval) {
                        var str_length = $attr['length'] ? $attr['length'] : 64,
                            decline = $attr['decline'] ? $attr['decline'] : '...',
                            hideTitle = (typeof $attr.compactHideTitle !== 'undefined') ? true : false;

                        if (nval.length > str_length) {
                            if (hideTitle === false)
                                $element.attr('title', nval);

                            $element.html($filter('limitTo')(nval, str_length) + decline);
                        } else {
                            $element.text(nval);
                        }


                    }, true);
                }
            };
        }
    ]);

    angular.module('graph').directive('ngDropdownMultiselect', ['$filter', '$document', '$compile', '$parse',
        function ($filter, $document, $compile, $parse) {

            return {
                restrict: 'AE',
                scope: {
                    selectedModel: '=',
                    options: '=',
                    extraSettings: '=',
                    events: '=',
                    searchFilter: '=?',
                    translationTexts: '=',
                    groupBy: '@'
                },
                template: function (element, attrs) {
                    var checkboxes = attrs.checkboxes ? true : false;
                    var groups = attrs.groupBy ? true : false;

                    var template = '<div class="multiselect-parent btn-group dropdown-multiselect">';
                    template += '<button type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{getButtonText()}}&nbsp;<span class="caret"></span></button>';
                    template += '<ul class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: scroll" >';
                    template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a data-ng-click="selectAll()"><span class="icon icon-done"></span>  {{texts.checkAll}}</a>';
                    template += '<li ng-show="settings.showUncheckAll"><a data-ng-click="deselectAll();"><span class="icon icon-close"></span>   {{texts.uncheckAll}}</a></li>';
                    template += '<li ng-hide="(!settings.showCheckAll || settings.selectionLimit > 0) && !settings.showUncheckAll" class="divider"></li>';
                    template += '<li ng-show="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control" style="width: 100%;" ng-model="searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
                    template += '<li ng-show="settings.enableSearch" class="divider"></li>';

                    if (groups) {
                        template += '<li ng-repeat-start="option in orderedItems | filter: searchFilter" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupTitle(getPropertyForObject(option, settings.groupBy)) }}</li>';
                        template += '<li ng-repeat-end role="presentation">';
                    } else {
                        template += '<li role="presentation" ng-repeat="option in options | filter: searchFilter">';
                    }

                    template += '<a role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp))">';

                    if (checkboxes) {
                        template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> {{getPropertyForObject(option, settings.displayProp)}}</label></div></a>';
                    } else {
                        template += '<span data-ng-class="{\'icon icon-done\': isChecked(getPropertyForObject(option,settings.idProp))}"></span> {{getPropertyForObject(option, settings.displayProp)}}</a>';
                    }

                    template += '</li>';

                    template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
                    template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                    template += '</ul>';
                    template += '</div>';

                    element.html(template);
                },
                link: function ($scope, $element, $attrs) {
                    var $dropdownTrigger = $element.children()[0];

                    $scope.toggleDropdown = function () {
                        $scope.open = !$scope.open;
                    };

                    $scope.checkboxClick = function ($event, id) {
                        $scope.setSelectedItem(id);
                        $event.stopImmediatePropagation();
                    };

                    $scope.externalEvents = {
                        onItemSelect: angular.noop,
                        onItemDeselect: angular.noop,
                        onSelectAll: angular.noop,
                        onDeselectAll: angular.noop,
                        onInitDone: angular.noop,
                        onMaxSelectionReached: angular.noop
                    };

                    $scope.settings = {
                        dynamicTitle: true,
                        scrollable: false,
                        scrollableHeight: '300px',
                        closeOnBlur: true,
                        displayProp: 'label',
                        idProp: 'id',
                        externalIdProp: 'id',
                        enableSearch: false,
                        selectionLimit: 0,
                        showCheckAll: true,
                        showUncheckAll: true,
                        closeOnSelect: false,
                        buttonClasses: 'btn btn-default',
                        closeOnDeselect: false,
                        groupBy: $attrs.groupBy || undefined,
                        groupByTextProvider: null,
                        smartButtonMaxItems: 0,
                        smartButtonTextConverter: angular.noop
                    };

                    $scope.texts = {
                        checkAll: 'Check All',
                        uncheckAll: 'Uncheck All',
                        selectionCount: 'checked',
                        selectionOf: '/',
                        searchPlaceholder: 'Search...',
                        buttonDefaultText: 'Select',
                        dynamicButtonTextSuffix: 'checked'
                    };

                    $scope.searchFilter = $scope.searchFilter || '';

                    if (angular.isDefined($scope.settings.groupBy)) {
                        $scope.$watch('options', function (newValue) {
                            if (angular.isDefined(newValue)) {
                                $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                            }
                        });
                    }

                    angular.extend($scope.settings, $scope.extraSettings || []);
                    angular.extend($scope.externalEvents, $scope.events || []);
                    angular.extend($scope.texts, $scope.translationTexts);

                    $scope.singleSelection = $scope.settings.selectionLimit === 1;

                    function getFindObj(id) {
                        var findObj = {};

                        if ($scope.settings.externalIdProp === '') {
                            findObj[$scope.settings.idProp] = id;
                        } else {
                            findObj[$scope.settings.externalIdProp] = id;
                        }

                        return findObj;
                    }

                    function clearObject(object) {
                        for (var prop in object) {
                            delete object[prop];
                        }
                    }

                    if ($scope.singleSelection) {
                        if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                            clearObject($scope.selectedModel);
                        }
                    }

                    if ($scope.settings.closeOnBlur) {
                        $document.on('click', function (e) {
                            var target = e.target.parentElement;
                            var parentFound = false;

                            while (angular.isDefined(target) && target !== null && !parentFound) {
                                if (_.contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                                    if(target === $dropdownTrigger) {
                                        parentFound = true;
                                    }
                                }
                                target = target.parentElement;
                            }

                            if (!parentFound) {
                                $scope.$apply(function () {
                                    $scope.open = false;
                                });
                            }
                        });
                    }

                    $scope.getGroupTitle = function (groupValue) {
                        if ($scope.settings.groupByTextProvider !== null) {
                            return $scope.settings.groupByTextProvider(groupValue);
                        }

                        return groupValue;
                    };

                    $scope.getButtonText = function () {
                        if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0))) {
                            if ($scope.settings.smartButtonMaxItems > 0) {
                                var itemsText = [];

                                angular.forEach($scope.options, function (optionItem) {
                                    if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                        var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                        var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                        itemsText.push(converterResponse ? converterResponse : displayText);
                                    }
                                });

                                if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                    itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                    itemsText.push('...');
                                }

                                return itemsText.join(', ');
                            } else {
                                var totalSelected;

                                if ($scope.singleSelection) {
                                    totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                                } else {
                                    totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                                }

                                if (totalSelected === 0) {
                                    return $scope.texts.buttonDefaultText;
                                } else {
                                    return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                                }
                            }
                        } else {
                            return $scope.texts.buttonDefaultText;
                        }
                    };

                    $scope.getPropertyForObject = function (object, property) {
                        if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                            return object[property];
                        }

                        return '';
                    };

                    $scope.selectAll = function () {
                        $scope.deselectAll(false);
                        $scope.externalEvents.onSelectAll();

                        angular.forEach($scope.options, function (value) {
                            $scope.setSelectedItem(value[$scope.settings.idProp], true);
                        });
                    };

                    $scope.deselectAll = function (sendEvent) {
                        sendEvent = sendEvent || true;

                        if (sendEvent) {
                            $scope.externalEvents.onDeselectAll();
                        }

                        if ($scope.singleSelection) {
                            clearObject($scope.selectedModel);
                        } else {
                            $scope.selectedModel.splice(0, $scope.selectedModel.length);
                        }
                    };

                    $scope.setSelectedItem = function (id, dontRemove) {
                        var findObj = getFindObj(id);
                        var finalObj = null;

                        if ($scope.settings.externalIdProp === '') {
                            finalObj = _.find($scope.options, findObj);
                        } else {
                            finalObj = findObj;
                        }

                        if ($scope.singleSelection) {
                            clearObject($scope.selectedModel);
                            angular.extend($scope.selectedModel, finalObj);
                            $scope.externalEvents.onItemSelect(finalObj);
                            if ($scope.settings.closeOnSelect) $scope.open = false;

                            return;
                        }

                        dontRemove = dontRemove || false;

                        var exists = _.findIndex($scope.selectedModel, findObj) !== -1;

                        if (!dontRemove && exists) {
                            $scope.selectedModel.splice(_.findIndex($scope.selectedModel, findObj), 1);
                            $scope.externalEvents.onItemDeselect(findObj);
                        } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
                            $scope.selectedModel.push(finalObj);
                            $scope.externalEvents.onItemSelect(finalObj);
                        }
                        if ($scope.settings.closeOnSelect) $scope.open = false;
                    };

                    $scope.isChecked = function (id) {
                        if ($scope.singleSelection) {
                            return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                        }

                        return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                    };

                    $scope.externalEvents.onInitDone();
                }
            };
        }]);

    angular.module('graph').directive('scrollDir', function () {
        return {
            restrict: 'A',
            link: function ($scope, element) {
                screen = window.innerHeight * 2;
                $scope.state = 0;
                $scope.text = 'Top';

                $scope.scrollTo = function() {
                    var commit = window.scrollY;

                    if (commit > screen) {
                        window.scrollTo(0, 0);
                        $scope.state = commit;
                        $scope.text = 'Back';
                        element.html($scope.text);
                    } else {
                        if ($scope.state > screen) {
                            window.scrollTo(0, $scope.state);
                            $scope.state = 0;
                            $scope.text = 'Top';
                            element.html($scope.text);
                        }
                    }
                }

                window.onmousemove = function(e) {
                    if(window.scrollY > screen){
                        element.css('opacity', '1');
                        element.css('visibility', 'visible');
                        element.css('transition', 'visibility 0s linear 0s, opacity 300ms');
                        $scope.text = 'Top';
                        element.html($scope.text);
                    } else {
                        if($scope.text == 'Top') {
                            element.css('opacity', '0');
                            element.css('visibility', 'hidden');
                            element.css('transition', 'visibility 0s linear 300ms, opacity 300ms');
                        }
                    }
                }
            }
        }
    });

    angular.module('graph').directive('readMore', function() {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                text: '=ngModel'
            },
            template:  "<div>" +
                    "<p ng-bind-html='text | readMoreFilter:[text, countingWords, textLength] | markdown'></p>"  +
                        "<a ng-show='showLinks' ng-click='changeLength()' class='color3'>" +
                        "<strong ng-show='isExpanded'>Show Less</strong>" +
                        "<strong ng-show='!isExpanded'>Show More</strong>" +
                    "</a>" +
                "</div>",
            controller: ['$scope', '$attrs', '$element',
                function($scope, $attrs) {
                    $scope.yPost = 0;
                    $scope.textLength = $attrs.length;
                    $scope.isExpanded = false;
                    $scope.countingWords = $attrs.words !== undefined ? ($attrs.words === 'true') : true;

                    if (!$scope.countingWords && $scope.text.length > $attrs.length) {
                        $scope.showLinks = true;
                    } else if ($scope.countingWords && $scope.text.split(" ").length > $attrs.length) {
                        $scope.showLinks = true;
                    } else {
                        $scope.showLinks = false;
                    }

                    $scope.changeLength = function (card) {
                        if ($scope.isExpanded === false)
                            $scope.yPos = window.scrollY;
                        else
                            window.scrollTo(0, $scope.yPos);

                        $scope.isExpanded = !$scope.isExpanded;
                        $scope.textLength = $scope.textLength !== $attrs.length ?  $attrs.length : $scope.text.length;
                    };
                }]
        };
    }).filter('readMoreFilter', function() {
        return function(str, args) {
            var strToReturn = str,
                length = str.length,
                foundWords = [],
                countingWords = (!!args[1]);

            if (typeof args[2] !== "number") {
                length = 50;
            }

            if (length <= 0) {
                return "";
            }


            if (str) {
                if (countingWords) { // Count words

                    foundWords = str.split(/\s+/);

                    if (foundWords.length > length) {
                        strToReturn = foundWords.slice(0, length).join(' ') + '...';
                    }

                } else {  // Count characters

                    if (str.length > length) {
                        strToReturn = str.slice(0, length) + '...';
                    }

                }
            }

            return strToReturn;
        };
    });
})();
